// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"3e31dde6","227":"dd59c418","453":"2c88876b","560":"89ef4483","648":"b5c4c252"}[chunkId] + ".chunk.js";
};